if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
  
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    addPromotionProducts() {
      // hard-coded promotion threshold and promotion products which should be checced and added when product is added to the cart
      const thresholdPriceValue = 25000; // $250
      const promotionProductsVariantIds = [
        "39453832314978", // no cold shoulder beanie -> https://eu.nobis.com/products/no-cold-shoulder-beanie-chalk
        "32007834927202" // no cold shoulder mailer https://admin.shopify.com/store/nobis-eu/products/4515730489442
      ];

      const isProductAvailableInCart = (productId, cart) => {
        if (!cart.items || cart.items.length === 0) {
          return false;
        }
  
        return cart.items.some((item) => `${item.id}` === productId);
      }

      jQuery.getJSON('/cart.js', function(cart) {
        const isEligibleForFreePromotionProducts = cart.total_price  >= thresholdPriceValue;
        const promotionProductsAvailableInCart = promotionProductsVariantIds.filter((productId) => isProductAvailableInCart(productId, cart));
        const promotionProductsMissingInCart = promotionProductsVariantIds.filter((productId) => !isProductAvailableInCart(productId, cart));

        if (isEligibleForFreePromotionProducts && promotionProductsMissingInCart.length > 0) {
          for (var i = 0; i < promotionProductsMissingInCart.length; i++) {
            var qty = 1;
            var data = {
              items: [{
                id: promotionProductsMissingInCart[i],
                quantity: qty
              }],
              sections: "cart-icon-bubble",
            };

            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data,
              cache: false,
              async: false,
              success: function(result){
                if (i !== promotionProductsMissingInCart.length - 1) return;

                const sectionsToRender = [{
                  id: 'cart-icon-bubble',
                  section: 'cart-icon-bubble',
                  selector: '.shopify-section'
                }];

                const getSectionInnerHTML = (html, selector) => {
                  return new DOMParser()
                    .parseFromString(html, 'text/html')
                    .querySelector(selector).innerHTML;
                }

                window.setTimeout(() => {
                  sectionsToRender.forEach(section => {
                    const elementToReplace =
                      document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

                    elementToReplace.innerHTML =
                      getSectionInnerHTML(result.sections[section.section], section.selector);
                  });
                }, 0);
              }
            });
            //Do something
          }
          
        } else {
          // Do nothing
        }
      });
      
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;
  
      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);
  
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
  
      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
  
      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        this.addPromotionProducts();
        
        if (response.product_type == "Jackets") {
          // var myStringArray = ["32005551718498","31129642172514"];
          var myStringArray = [];
          var arrayLength = myStringArray.length;
          for (var i = 0; i < arrayLength; i++) {
            var qty = 1;
            var data = {
              items: [{
                id: myStringArray[i],
                quantity: qty
              }],
              sections: "cart-icon-bubble",
            };

  
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data,
              cache: false,
              async: false,
              success: function(result){
                if (i !== arrayLength - 1) return;
                
                const sectionsToRender = [{
                  id: 'cart-icon-bubble',
                  section: 'cart-icon-bubble',
                  selector: '.shopify-section'
                }];
          
                const getSectionInnerHTML = (html, selector) => {
                  return new DOMParser()
                    .parseFromString(html, 'text/html')
                    .querySelector(selector).innerHTML;
                }
  
                window.setTimeout(() => {
                  sectionsToRender.forEach(section => {
                    const elementToReplace =
                      document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
    
                    elementToReplace.innerHTML =
                      getSectionInnerHTML(result.sections[section.section], section.selector);
                  });
                }, 0);
              }
            });
          }
        }

        jQuery.getJSON(window.Shopify.routes.root + 'products/'+response.handle+'.js', function(product) {
          $.each( product.tags, function( key, value ) {
            if (value.indexOf("product_") >= 0){
              var colorsList="";
              let sizeList = "";
              var tagss=value.split('product_');
              jQuery.getJSON(window.Shopify.routes.root + 'products/'+tagss[1]+'.js', function(addOnProduct) {
                var variants=addOnProduct.variants;
               
                var options='<span class="select-label">Select Colour</span>';
                var initialSelectedColor = ''
                const colorOptionIndex = addOnProduct.options.findIndex(option => option.name.toLowerCase() === "color");
                const sizeOptionIndex = addOnProduct.options.findIndex(option => option.name.toLowerCase() === "size");

                $.each(addOnProduct.options,function(t,e){
                  if(e.name == "Color"){
                    initialSelectedColor = e.values[0];
                    $.each(e.values,function(index,value){
                      var img=$('.option_image[data-color="'+value.toLowerCase()+'"]').val();
                      colorsList+='<li class="color_product_upsell yes tooltip '+(index==0?"active":"")+'" data-productid="'+addOnProduct.id+'"  data-color="'+value+'"><div class="color-name" ><img src="'+img+'"></div></li>';
                    });
                  }
                });

                const variantsSelectedColorMatch = addOnProduct.variants.filter(variant => variant.options.includes(initialSelectedColor));
                const firstAvailableVariant = variantsSelectedColorMatch.find(variant => variant.available);
                const firstAvailableVariantId = firstAvailableVariant?.id || "";
          
                $.each(addOnProduct.options,function(t,e){
                  if(e.name == "Size"){
                    const firstAvailableSize = firstAvailableVariant?.options[sizeOptionIndex];
                    sizeList = `<option value="" disabled ${firstAvailableSize ? "" : "selected"}>- Select Size -</option>`;
                    
                    $.each(variantsSelectedColorMatch, function(index, variant){
                      const sizeValue = variant.options[sizeOptionIndex];
                      
                      sizeList += `<option value="${sizeValue}" ${firstAvailableSize === sizeValue ? "selected" : ""} ${variant.available ? "" : "disabled"}>${sizeValue}</option>`;
                    });
                  }
                });
                var priceAddOn=parseFloat(addOnProduct.price / 100).toFixed(2);
                const featuredImage = firstAvailableVariant?.featured_image?.src || addOnProduct.featured_image;
                $('.ao__collection').css("display","none");
                $('.add_on--product-section').html(`
                  <div class="heading">
                    <h2>Did you see this?</h2>
                  </div>
                  <div class="add_on-product-main">
                    <div class="add-on-product-content">
                      <div class="ao-img-text">
                        <div class="ao-product-image">
                          <img src="${featuredImage}" />
                        </div>
                        <div class="ao__detail">
                          <a href="${addOnProduct.url}">
                            <h3 class="cart-notification-product__name h4">${addOnProduct.title}</h3>
                          </a>
                          <div class="ao__price">€${priceAddOn} EUR</div>
                          <ul class="ao-color-list">${colorsList}</ul>
                          <select class="size_options size_options_upsell" data-productid="${addOnProduct.id}">${sizeList}</select>
                          <input type=hidden class="main-input" value="${firstAvailableVariantId}">
                        </div>
                      </div>
                    </div>
                  </div>
                `);

                const submitButton = document.createElement("button");
                submitButton.addEventListener('click', event => {
                  event.preventDefault();
                  const qty = 1;
                  const input_value = $(".main-input").val();

                  if (!input_value) {
                    console.error('no variant id provided');
                    return;
                  }
  
                  $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    dataType: 'json',
                    data: {
                      id: input_value,
                      quantity: qty
                    },
                    cache: false,
                    async: false,
                    success: function(response){
                      if (response.product_type == "Jackets") {
                        var myStringArray = ["32005551718498","31129642172514"];
                        var arrayLength = myStringArray.length;
                        for (var i = 0; i < arrayLength; i++) {          
                          var qty = 1;
                          var data = {
                            items: [{
                              id: myStringArray[i],
                              quantity: qty
                            }],
                            sections: "cart-icon-bubble",
                          };
                
                          $.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            dataType: 'json',
                            data,
                            cache: false,
                            async: false,
                            success: function() {
                              window.location = "/cart";
                            }
                          });
                        }
                      } else {
                        window.location = "/cart";
                      }
                    }
                  });
                });
                
                submitButton.setAttribute("type", "submit");
                submitButton.setAttribute("name", "add");
    
                if (!firstAvailableVariantId) {
                  submitButton.setAttribute("disabled", true);
                }
  
                submitButton.classList.add("product-form__submit", "addOn-submit", "button", "button--full-width", "button--primary");
                submitButton.innerText = "Add to Cart";
                $('.add-on-product-content').append(submitButton);

                $.each(variants,function(index,variant){
                  var variant_loop = variant.id;
                  var variant_title = variant.title;
                  var isAvailable = variant.available;
                  var variantImage = variant.featured_image?.src;
                  var variantColor = variant.options[colorOptionIndex];
                  var variantSize = variant.options[sizeOptionIndex];
            
                  $('.ao__detail').append(`
                    <input type=hidden value="${variant_loop}" data-title="${variant_title}" data-available="${isAvailable}" data-image="${variantImage}" data-color="${variantColor}" data-size="${variantSize}">
                  `);
                });
              });
            } else {
  //           	$('.ao__collection').css("display","block");
            }
          });
        });

        this.cartNotification.renderContents(response);
        
        // close quick-add-modal component
        document.body.classList.remove('overflow-hidden');
        $('quick-add-modal[open]').each(function() {
          this.hide();
          this.removeAttribute('open');
        });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
    
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

$(document).on('click','.color_product_upsell',function(){
  $('.color_product_upsell').removeClass('active');
  $(this).addClass('active');

  var color=$(this).data('color');
  var size=$('.size_options_upsell').val();
  var select_title = color+' / '+size;
  var selected_variant = $('input[data-title="'+select_title+'"]');
  var selected_variant_id = selected_variant.val();
  var is_selected_variant_available = selected_variant.attr('data-available');
  let selected_variant_image = selected_variant.attr('data-image');

  $(".main-input").val(selected_variant_id);

  const allColorMatchVariantInputs = $(`.ao__detail input[data-color="${color}"]`);
  let firstAvailableSize;
  const availableSizeInputs = allColorMatchVariantInputs.filter((index, variantInput) => variantInput.getAttribute("data-available") === "true");
  const submitButton = $('.product-form__submit.addOn-submit.button');
  
  if (availableSizeInputs.length) {
    firstAvailableSize = availableSizeInputs[0].getAttribute("data-size");
    submitButton.prop('disabled', false);
  } else {
    submitButton.prop('disabled', true);
  }

  if (!selected_variant_image) {
    selected_variant_image = allColorMatchVariantInputs[0].getAttribute("data-image");
  }

  $('.ao-product-image').html(`<img src="${selected_variant_image}" />`);

  let sizeList = `<option value="" disabled ${firstAvailableSize ? "" : "selected"}>- Select Size -</option>`;
  let isPreviouslySelectedSizeNotAvailable = false;

  $.each(allColorMatchVariantInputs, function(index, variantInput) {
    const sizeValue = variantInput.getAttribute("data-size");
    const isAvailable = variantInput.getAttribute("data-available") === "true";

    if (sizeValue === size && !isAvailable) {
      isPreviouslySelectedSizeNotAvailable = true;
    }
    
    sizeList += `<option value="${sizeValue}" ${firstAvailableSize === sizeValue ? "selected" : ""} ${isAvailable ? "" : "disabled"}>${sizeValue}</option>`;
  });

  $('.size_options.size_options_upsell').html(sizeList);
});
$('#cart-notification-form').submit(function(e) {
  e.preventDefault(); // Prevent the form from submitting initially
  
  var url = window.location.href;
  var parts = url.split('/');
  var lastPart = parts[parts.length - 1];
  if (lastPart.includes('?')) {
      lastPart = lastPart.split('?')[0];
  }
  console.log("form stopped", lastPart);
  const confirmationPopup = document.getElementById('confirmationPopup');
  const popupMessage = confirmationPopup.getAttribute('data-popup-message');

  var extractedProductHandle = lastPart;
  jQuery.getJSON(window.Shopify.routes.root + 'products/'+extractedProductHandle+'.js', function(product) {
    console.log(product.tags, "test")
      if (product.tags.includes("jacket") || product.tags.includes("jackets")) {
            // $("html, body").animate({ scrollTop: 0 }, "slow");
            const confirmationPopup = document.createElement('div');
            confirmationPopup.classList.add('confirmation-popup');
            confirmationPopup.innerHTML = `
            <button class="close-button-popup">×</button>
            <div class="confirmation-text">${popupMessage}</div>
            <div class="free-options-container">
              <div>                
                <label>
                <img srcset="//nobis-ca.myshopify.com/cdn/shop/products/Packaging-Photo.png?v=1603988234&amp;width=493 493w,
                //nobis-ca.myshopify.com/cdn/shop/products/Packaging-Photo.png?v=1603988234&amp;width=600 600w,
                //nobis-ca.myshopify.com/cdn/shop/products/Packaging-Photo.png?v=1603988234&amp;width=713 713w,
                //nobis-ca.myshopify.com/cdn/shop/products/Packaging-Photo.png?v=1603988234&amp;width=823 823w,
                //nobis-ca.myshopify.com/cdn/shop/products/Packaging-Photo.png?v=1603988234&amp;width=990 990w,
                //nobis-ca.myshopify.com/cdn/shop/products/Packaging-Photo.png?v=1603988234&amp;width=1100 1100w,
                //nobis-ca.myshopify.com/cdn/shop/products/Packaging-Photo.png?v=1603988234&amp;width=1206 1206w,
                //nobis-ca.myshopify.com/cdn/shop/products/Packaging-Photo.png?v=1603988234&amp;width=1346 1346w,
                //nobis-ca.myshopify.com/cdn/shop/products/Packaging-Photo.png?v=1603988234&amp;width=1426 1426w,
                //nobis-ca.myshopify.com/cdn/shop/products/Packaging-Photo.png?v=1603988234&amp;width=1646 1646w,
                //nobis-ca.myshopify.com/cdn/shop/products/Packaging-Photo.png?v=1603988234&amp;width=1946 1946w,
                //nobis-ca.myshopify.com/cdn/shop/products/Packaging-Photo.png?v=1603988234 2000w" src="//nobis-ca.myshopify.com/cdn/shop/products/Packaging-Photo.png?v=1603988234&amp;width=1946" sizes="(min-width: 1600px) 675px, (min-width: 990px) calc(45.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)" loading="lazy" width="973" height="1287" alt="">
                Gift Box<input type="checkbox" id="gift-checkbox"></label>
              </div>
              <div>                
                <label>
                <img srcset="//nobis-ca.myshopify.com/cdn/shop/products/Garment-Bag-Product-Image_ec234854-da03-43fa-b6c4-9649d22e8636.jpg?v=1598646832&amp;width=493 493w,
                //nobis-ca.myshopify.com/cdn/shop/products/Garment-Bag-Product-Image_ec234854-da03-43fa-b6c4-9649d22e8636.jpg?v=1598646832&amp;width=600 600w,
                //nobis-ca.myshopify.com/cdn/shop/products/Garment-Bag-Product-Image_ec234854-da03-43fa-b6c4-9649d22e8636.jpg?v=1598646832&amp;width=713 713w,
                //nobis-ca.myshopify.com/cdn/shop/products/Garment-Bag-Product-Image_ec234854-da03-43fa-b6c4-9649d22e8636.jpg?v=1598646832&amp;width=823 823w,
                //nobis-ca.myshopify.com/cdn/shop/products/Garment-Bag-Product-Image_ec234854-da03-43fa-b6c4-9649d22e8636.jpg?v=1598646832&amp;width=990 990w,
                //nobis-ca.myshopify.com/cdn/shop/products/Garment-Bag-Product-Image_ec234854-da03-43fa-b6c4-9649d22e8636.jpg?v=1598646832&amp;width=1100 1100w,
                //nobis-ca.myshopify.com/cdn/shop/products/Garment-Bag-Product-Image_ec234854-da03-43fa-b6c4-9649d22e8636.jpg?v=1598646832&amp;width=1206 1206w,
                //nobis-ca.myshopify.com/cdn/shop/products/Garment-Bag-Product-Image_ec234854-da03-43fa-b6c4-9649d22e8636.jpg?v=1598646832&amp;width=1346 1346w,
                //nobis-ca.myshopify.com/cdn/shop/products/Garment-Bag-Product-Image_ec234854-da03-43fa-b6c4-9649d22e8636.jpg?v=1598646832&amp;width=1426 1426w,
                //nobis-ca.myshopify.com/cdn/shop/products/Garment-Bag-Product-Image_ec234854-da03-43fa-b6c4-9649d22e8636.jpg?v=1598646832&amp;width=1646 1646w,
                //nobis-ca.myshopify.com/cdn/shop/products/Garment-Bag-Product-Image_ec234854-da03-43fa-b6c4-9649d22e8636.jpg?v=1598646832&amp;width=1946 1946w,
                //nobis-ca.myshopify.com/cdn/shop/products/Garment-Bag-Product-Image_ec234854-da03-43fa-b6c4-9649d22e8636.jpg?v=1598646832 2000w" src="//nobis-ca.myshopify.com/cdn/shop/products/Garment-Bag-Product-Image_ec234854-da03-43fa-b6c4-9649d22e8636.jpg?v=1598646832&amp;width=1946" sizes="(min-width: 1600px) 675px, (min-width: 990px) calc(45.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)" loading="lazy" width="973" height="1287" alt="">
                Garment Bag<input type="checkbox" id="garment-checkbox"></label>
              </div>
            </div>
            <button class="free-options-submit button">Submit</button>
            `;
            document.body.appendChild(confirmationPopup);
            var selectedOptions = [];
    
            function updateSelectedOptions() {
                selectedOptions = [];
                // var myStringArray = ["32159129600102","31106419490918"];
                // var myStringArray = ["32005551718498","31129642172514"];
              
                if ($('#garment-checkbox').is(':checked')) {
                    selectedOptions.push("31129642172514"); // Add garment value to array
                }
                if ($('#gift-checkbox').is(':checked')) {
                    selectedOptions.push("32005551718498"); // Add gift value to array
                }
            }
            $('.free-options-container input[type="checkbox"]').change(function() {
                updateSelectedOptions(); 
                console.log(selectedOptions);
            });
            $('.close-button-popup').click(function() {
              window.location.href = '/checkout';
            })
            document.addEventListener("click", function(event) {
                const popup = document.querySelector(".confirmation-popup");
                const closeButton = document.querySelector(".close-button-popup");
            
                if (!popup.contains(event.target) || event.target === closeButton) {
                    window.location.href = '/checkout';
                }
            });
            
            $('.free-options-submit').click(function() {
              var myStringArray = selectedOptions;
              var arrayLength = myStringArray.length;
              for (var i = 0; i < arrayLength; i++) {
                var qty = 1;
                var data = {
                  items: [{
                    id: myStringArray[i],
                    quantity: qty
                  }],
                  sections: "cart-icon-bubble",
                };
    
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  dataType: 'json',
                  data,
                  cache: false,
                  async: false,
                  success: function(result){
                    if (i !== arrayLength - 1) return;
    
                    const sectionsToRender = [{
                      id: 'cart-icon-bubble',
                      section: 'cart-icon-bubble',
                      selector: '.shopify-section'
                    }];
    
                    const getSectionInnerHTML = (html, selector) => {
                      return new DOMParser()
                        .parseFromString(html, 'text/html')
                        .querySelector(selector).innerHTML;
                    }
    
                    window.setTimeout(() => {
                      sectionsToRender.forEach(section => {
                        const elementToReplace =
                          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
    
                        elementToReplace.innerHTML =
                          getSectionInnerHTML(result.sections[section.section], section.selector);
                      });
                    }, 0);
                  }
                });
                //Do something
              }
              $('.confirmation-popup').remove();
              window.location.href = '/checkout';
            })
          } else {
        window.location.href = '/checkout';
      }
  });
})
$(document).on('change','.size_options_upsell',function(){
  var color=$('.color_product_upsell.active').data('color');
  var size=$(this).val();
  var select_title = color+' / '+size;
  var selected_variant = $('input[data-title="'+select_title+'"]');
  var selected_variant_id = selected_variant.val();
  var is_selected_variant_available = selected_variant.attr('data-available');
  var selected_variant_image = selected_variant.attr('data-image');

  $('.ao-product-image').html(`<img src="${selected_variant_image}" />`);
  $(".main-input").val(selected_variant_id);
});
